<script>
  import * as restfulService from '../../../services/restfulService'
  import * as MESSAGES from '../../../messages'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters, mapActions} from 'vuex'

  import {required} from 'vuelidate/lib/validators'
  import {clone} from 'lodash'

  export default {
    props: {
      mostrar: {
        default: false,
        type: Boolean
      }
    },
    mixins: [helpers],
    data () {
      return {
        botaoClicado: false,
        mostrarModal: false,
        form: {
          matricula: '',
          nome: '',
          email: '',
          assunto: '',
          mensagem: ''
        }
      }
    },
    validations: {
      form: {
        nome: {required},
        email: {required},
        assunto: {required},
        mensagem: {required}
      }
    },
    watch: {
      mostrar: function (newValue) {
        this.mostrarModal = newValue
      },
      mostrarModal: function (newValue, oldValue) {
        if (!newValue && oldValue) {
          this.$emit('update:mostrar', newValue)
        } else {
          if (this.currentUser.id) {
            this.form.matricula = this.currentUser.ref_pessoa
            this.form.nome = this.currentUser.pessoa.nome
            this.form.email = this.currentUser.pessoa.email
            setTimeout(() => {
              this.$refs.formAssunto.focus()
            }, 300)
          } else {
            setTimeout(() => {
              this.$refs.formMatricula.focus()
            }, 300)
          }
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      formNomeErros () {
        const erros = []
        if (!this.$v.form.nome.$dirty) return erros
        !this.$v.form.nome.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      formEmailErros () {
        const erros = []
        if (!this.$v.form.email.$dirty) return erros
        !this.$v.form.email.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        !this.$v.form.email.email && erros.push(MESSAGES.VALIDATION_EMAIL)
        return erros
      },
      formAssuntoErros () {
        const erros = []
        if (!this.$v.form.assunto.$dirty) return erros
        !this.$v.form.assunto.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      formMensagemErros () {
        const erros = []
        if (!this.$v.form.mensagem.$dirty) return erros
        !this.$v.form.mensagem.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      enviarMensagem () {
        this.botaoClicado = true
        bus.$emit('show-loader')
        let data = clone(this.form)
        restfulService.post('usuario', 'contato', null, data)
          .then(() => {
            this.showNotification({
              message: 'Sua mensagem foi enviada, retornaremos o mais breve possível'
            })
            this.$v.form.$reset()
            this.form = Object.assign({}, {
              matricula: '',
              nome: '',
              email: '',
              assunto: '',
              mensagem: ''
            })
            this.botaoClicado = false
            this.mostrarModal = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.botaoClicado = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <v-dialog v-model="mostrarModal" :width="isMobile().any() ? '90%' : '50%'">
        <v-card>
            <v-card-title class="primary white--text"
                          >
                Formulário de Contato
            </v-card-title>
            <v-card-text>
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field v-model="form.matricula"
                                          ref="formMatricula"
                                          type="tel"
                                          label="Matrícula"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field v-model="form.nome"
                                          :error-messages="formNomeErros"
                                          @input="$v.form.nome.$touch()"
                                          @blur="$v.form.nome.$touch()"
                                          label="Nome Completo"
                                          required/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field v-model="form.email"
                                          :error-messages="formEmailErros"
                                          @input="$v.form.email.$touch()"
                                          @blur="$v.form.email.$touch()"
                                          label="E-mail"
                                          required/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field v-model="form.assunto"
                                          ref="formAssunto"
                                          :error-messages="formAssuntoErros"
                                          @input="$v.form.assunto.$touch()"
                                          @blur="$v.form.assunto.$touch()"
                                          label="Assunto"
                                          required/>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea v-model="form.mensagem"
                                        :error-messages="formMensagemErros"
                                        @input="$v.form.mensagem.$touch()"
                                        @blur="$v.form.mensagem.$touch()"
                                        label="Mensagem"
                                        hint="Mensagem"
                                        required/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success"
                       @click="enviarMensagem"
                       :disabled="botaoClicado || $v.form.$invalid">
                    Enviar Mensagem
                </v-btn>
                <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>



// WEBPACK FOOTER //
// Contato.vue?269967b2